import {
  Object3D,
  Vector2
} from 'three';

import { Text2D } from 'ohzi-core';


export default class OhziLabels extends Object3D {
  constructor(text, size, color = '#000000') {
    super();
    this.font = '200px Arial';
    this.size = size;
    this.color = color;

    if (!text) {
      return;
    }
    this.createLabel(text);
  }

  removeLabel() {
    this.remove(this.label);
  }

  createLabel(text) {
    this.label = new Text2D(text, this.font, this.color, new Vector2(1.0, 0.0), false);
    this.label.rotation.y = Math.PI * 0.5;
    this.label.size = this.size;
    this.add(this.label);
  }

  set visible(isVisible) {
    if (this.label) {
      this.label.visible = isVisible;
    }
  }

  set text(text) {
    const attributes = ['renderOrder', 'size', 'visible'];
    const attributesCache = {};
    if (this.label) {
    //   [...attributes, 'position', 'rotation'].forEach(attr => {
    //     if (this.label[attr]) {
    //       attributesCache[attr] = this.label[attr];
    //     }
    //   });
      this.removeLabel();
    }
    this.createLabel(text);
    // const pos = attrs['position'];
    // if (pos) {
    //   this.label.position.x = pos.x;
    //   this.label.position.y = pos.y;
    //   this.label.position.z = pos.z;
    // }
    // const rot = attributesCache['rotation'];
    // if (rot) {
    //   this.label.rotation.x = rot.x;
    //   this.label.rotation.y = rot.y;
    //   this.label.rotation.z = rot.z;
    // }
    // attributes.forEach(attr => {
    //   this.label[attr] = attributesCache[attr];
    // });
  }
}